'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of multi patient add web
 */ const MultiPatientAddWeb = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "19.9531",
                y: "31.6211",
                width: "63.9459",
                height: "37.2433",
                rx: "3.46892",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.9531 62.1255V65.4044C19.9531 67.3203 21.5062 68.8734 23.422 68.8734H80.4301C82.346 68.8734 83.8991 67.3203 83.8991 65.4044V62.1255H19.9531Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.1602",
                y: "68.8594",
                width: "19.6757",
                height: "6.04325",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.2734",
                y: "74.7676",
                width: "33.3081",
                height: "1.68649",
                rx: "0.843243",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M34.0117 41.424C34.0117 43.8678 35.9735 45.8479 38.391 45.8479C40.8085 45.8479 42.7703 43.8678 42.7703 41.424C42.7703 38.9801 40.8102 37 38.391 37C35.9718 37 34.0117 38.9801 34.0117 41.424Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M42.1514 47.0137C41.0764 47.7473 39.7803 48.1771 38.3854 48.1771C36.9904 48.1771 35.6927 47.7473 34.6193 47.0137C32.4993 48.2073 31.0625 50.4822 31.0625 53.0894V53.996C31.0625 54.9832 31.8613 55.7722 32.8342 55.7722H42.2636V55.3542C42.2636 53.0206 43.1327 50.8834 44.5578 49.2566C43.9482 48.3316 43.121 47.561 42.1514 47.0137Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M65.473 37C63.0538 37 61.0938 38.9801 61.0938 41.424C61.0938 43.8678 63.0555 45.8479 65.473 45.8479C67.8905 45.8479 69.8523 43.8678 69.8523 41.424C69.8523 38.9801 67.8922 37 65.473 37Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M69.2451 47.0153C68.1691 47.7489 66.8719 48.1786 65.4758 48.1786C64.0797 48.1786 62.7807 47.7489 61.7047 47.0137C60.7377 47.5575 59.9131 48.3229 59.3047 49.2461C60.731 50.8709 61.6008 53.0077 61.6008 55.3543V55.7722H71.0268C72.0122 55.7722 72.8 54.9833 72.8 53.9963V53.0899C72.8 50.4815 71.367 48.2088 69.2451 47.0153Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M47.5078 43.6957C47.5078 46.1149 49.4896 48.0749 51.9318 48.0749C54.374 48.0749 56.3557 46.1149 56.3557 43.6957C56.3557 41.2765 54.3756 39.3164 51.9318 39.3164C49.4879 39.3164 47.5078 41.2765 47.5078 43.6957Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M55.726 49.2422C54.6432 49.9754 53.3377 50.405 51.9327 50.405C50.5277 50.405 49.2205 49.9754 48.1377 49.2422C46.0024 50.4335 44.5586 52.7037 44.5586 55.3128V56.2222C44.5586 57.2054 45.3598 58.0007 46.3465 58.0007H57.5172C58.5039 58.0007 59.3051 57.2037 59.3051 56.2222V55.3128C59.3051 52.7037 57.8613 50.4335 55.726 49.2422Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "71.658",
                cy: "51.5135",
                r: "3.51351",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("line", {
                x1: "71.6268",
                y1: "49.7342",
                x2: "71.6268",
                y2: "53.3162",
                stroke: "#FAFFFC",
                strokeWidth: "0.941071",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("line", {
                x1: "73.4631",
                y1: "51.5545",
                x2: "69.881",
                y2: "51.5545",
                stroke: "#FAFFFC",
                strokeWidth: "0.941071",
                strokeLinecap: "round"
            })
        ]
    });
};

exports.MultiPatientAddWeb = MultiPatientAddWeb;
//# sourceMappingURL=MultiPatientAddWeb.cjs.map
